import React, { useEffect } from 'react'
import Header from '../Components/Header'
import { Avatar, Box, Container, Icon, IconButton, Typography } from '@mui/material'
import image from "../Image.jpg"
import Footer from '../Components/Footer'
import illustation from "../illustration.png"
import photo from "../PXL_20231009_125631885.jpg"
import { LinkedIn, GitHub, Instagram, Facebook, Mail, Description, FormatQuote } from '@mui/icons-material'
import cover from "../cover1.jpg";
import UsesList from "../Data/UsesList.json";
import { t } from 'i18next'
import Project from '../Components/Project'


interface Props { }

function Uses(props: Props) {
    const { } = props

    return (
        <div style={{ backgroundColor: "inherit" }} >
            <Header /><br /><br /><br /><br />
            <Container style={{ height: '100%' }} className='conatainer'>
                <br />
                <Box>
                    <Box className='pres' sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <Box>
                            <Box className='profil' >
                                <Typography variant='h4' style={{ fontWeight: "bold" }} align='left'>
                                    {t("front-end-dev")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box><br />
                <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                    {UsesList.map((f: any, index) => (
                        (index == 0 || index == 1 || index == 2) ? <Project logo={f.logo} link={f.link} linkName={t(f.title)} date={t(f.date)} title={t(f.title)} description={t(f.desc)} /> : ''
                    ))}
                </Box>


                <Box>
                    <Box className='pres' sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <Box>
                            <Box className='profil' >
                                <Typography variant='h4' style={{ fontWeight: "bold" }} align='left'>
                                    {t("back-end-dev")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box><br />

                <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                    {UsesList.map((f: any, index) => (
                        (index == 0 || index == 1 || index == 2) ? <Project logo={f.logo} link={f.link} linkName={t(f.title)} date={t(f.date)} title={t(f.title)} description={t(f.desc)} /> : ''
                    ))}
                </Box>

                <Box>
                    <Box className='pres' sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <Box>
                            <Box className='profil' >
                                <Typography variant='h4' style={{ fontWeight: "bold" }} align='left'>
                                    {t("bd")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box><br />

                <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                    {UsesList.map((f: any, index) => (
                        (index == 0 || index == 1 || index == 2) ? <Project logo={f.logo} link={f.link} linkName={t(f.title)} date={t(f.date)} title={t(f.title)} description={t(f.desc)} /> : ''
                    ))}
                </Box>

                



                <Box>
                    <Box className='pres' sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <Box>
                            <Box className='profil' >
                                <Typography variant='h4' style={{ fontWeight: "bold" }} align='left'>
                                    {t("cloud")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box><br />

                <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                    {UsesList.map((f: any, index) => (
                        (index == 0 || index == 1 || index == 2) ? <Project logo={f.logo} link={f.link} linkName={t(f.title)} date={t(f.date)} title={t(f.title)} description={t(f.desc)} /> : ''
                    ))}
                </Box>

                

                <Box>
                    <Box className='pres' sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <Box>
                            <Box className='profil' >
                                <Typography variant='h4' style={{ fontWeight: "bold" }} align='left'>
                                    {t("deploiement")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box><br />

                <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                    {UsesList.map((f: any, index) => (
                        (index == 0 || index == 1 || index == 2) ? <Project logo={f.logo} link={f.link} linkName={t(f.title)} date={t(f.date)} title={t(f.title)} description={t(f.desc)} /> : ''
                    ))}
                </Box>


                
                <Box>
                    <Box className='pres' sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <Box>
                            <Box className='profil' >
                                <Typography variant='h4' style={{ fontWeight: "bold" }} align='left'>
                                    {t("gestion-projet")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box><br />

                <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                    {UsesList.map((f: any, index) => (
                        (index == 0 || index == 1 || index == 2) ? <Project logo={f.logo} link={f.link} linkName={t(f.title)} date={t(f.date)} title={t(f.title)} description={t(f.desc)} /> : ''
                    ))}
                </Box>
                
                <Box>
                    <Box className='pres' sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <Box>
                            <Box className='profil' >
                                <Typography variant='h4' style={{ fontWeight: "bold" }} align='left'>
                                    {t("ia")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box><br />

                <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                    {UsesList.map((f: any, index) => (
                        (index == 0 || index == 1 || index == 2) ? <Project logo={f.logo} link={f.link} linkName={t(f.title)} date={t(f.date)} title={t(f.title)} description={t(f.desc)} /> : ''
                    ))}
                </Box>


            </Container>
            <Footer />
        </div>
    )
}

export default Uses
